import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 backdrop-blur-md",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary/90 text-primary-foreground hover:bg-primary/80 shadow-sm",
        secondary:
          "border-transparent bg-white/40 dark:bg-white/10 text-foreground hover:bg-white/50 dark:hover:bg-white/20 border-white/20",
        destructive:
          "border-transparent bg-destructive/90 text-destructive-foreground hover:bg-destructive/80 shadow-sm",
        outline: "text-foreground border-white/30",
        glass:
          "border-white/20 bg-white/30 dark:bg-white/10 text-foreground hover:bg-white/40 shadow-sm",
        active:
          "border-transparent bg-green-500/15 text-green-700 dark:text-green-400 border border-green-500/20",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
